import create from 'zustand';

// Local dependencies
import { DataProviderProps } from '../types';

interface FYMBaseDataStore extends DataProviderProps {
  setBaseData: (userData: Object) => void;
  resetBaseData: () => void;
}

const defaultFYMBaseDataStore: DataProviderProps = {
  loading: true,
  error: false,
  formData: [],
};

export const useFYMBaseDataStore = create<FYMBaseDataStore>((set) => ({
  ...defaultFYMBaseDataStore,
  setBaseData: (baseData: Object) =>
    set((store) => {
      return { ...store, ...baseData };
    }),
  resetBaseData: () =>
    set((store) => {
      return { ...store, ...defaultFYMBaseDataStore };
    }),
}));
